module.exports = __webpack_public_path__ + "img/dpd-cod.272323c5.png";